import axios from "src/lib/axios";
import { IUserGroupData } from "./Types/MobileUserGroup";
import AlertMessage from "src/components/ui-components/AlertMessage";
import { MenuData } from "./Types/MenuAndSubmenu";

const API_URLS = {
  GET_MOBILE_USER_GROUPS: `/UserGroups/GetUserGroupsDetails`,
  INSERT_UPDATE_USER_GROUPS: `/UserGroups/InsertUpdateUserGroupDetails`,
  UPDATE_DISABLE_STATUS: `/UserGroups/EnableDisableUserGroup`,
  GET_APP_MENUS: `/PageGroupMasterMapping`,
  GET_USER_GROUP_MENUS: `/UserGroups/GetPageGroupsAndPagesForUserGroup`,
  INSERT_UPDATE_PAGES_FOR_MOBILE_GROUPS: `/UserGroups/InsertUpdatePageGroupsAndPagesForUserGroup`,
  IS_USERGROUP_PRESENT: `/UserGroups/GetUserGroupByParentKey`,
  GET_MOBILE_ROLE_CODE_MASTER: `/UserGroups/GetMobileRoleCodeMaster`,
};

export const GetMobileUserGroups = async () => {
  try {
    const mobileUserGroups = await axios.get<IUserGroupData[]>(API_URLS.GET_MOBILE_USER_GROUPS);
    return mobileUserGroups.data;
  } catch {
    return [];
  }
};

export const GetAppMenusAndSubmenus = async () => {
  try {
    const menus = await axios.get<MenuData[]>(API_URLS.GET_APP_MENUS);
    return menus.data || [];
  } catch {
    return [];
  }
};

export const GetMobileUserGroupByKey = async (userGroupKey: string) => {
  try {
    const mobileUserGroup = await axios.get<IUserGroupData>(API_URLS.GET_MOBILE_USER_GROUPS, { params: { userGroupKey } });
    return mobileUserGroup.data[0];
  } catch {
    return {};
  }
}

export const InsertUpdateMobileUserGroup = async (values) => {
  try {
    const res = await axios.post(API_URLS.INSERT_UPDATE_USER_GROUPS, values);
    AlertMessage({ type: 'success', msg: res.data.message });
    return res;
  } catch (err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
  }
};

export const UpdateDisableStatus = async (UserGroupKey: string, IsDisabled: boolean) => {
  try {
    const res = await axios.put(`${API_URLS.UPDATE_DISABLE_STATUS}?UserGroupKey=${UserGroupKey}&IsDisabled=${IsDisabled}`);
    AlertMessage({ type: 'success', msg: res.data.message });
  } catch (err) {
    Object.entries(err.errors).forEach(([, errMsg]: any) => {
      AlertMessage({ type: 'error', msg: errMsg.errorMessage });
    });
    return false;
  }
};

export const GetMobileUserGroupMenus = async (userGroupKey: string) => {
  try {
    const mobileUserGroup = await axios.get<string[]>(API_URLS.GET_USER_GROUP_MENUS, { params: { userGroupKey } });
    return mobileUserGroup.data || [];
  } catch {
    return [];
  }
};

export const InsertUpdatePagesForMobileUserGroup = async (values) => {
  try {
    const res = await axios.post(API_URLS.INSERT_UPDATE_PAGES_FOR_MOBILE_GROUPS, values);
    AlertMessage({ type: 'success', msg: res.data.message });
    return res.data.status === 200;
  } catch (err) {
    if (err?.response?.data?.errors) {
      Object.entries(err.response.data.errors).forEach(([, errMsg]: any) => {
        AlertMessage({ type: 'error', msg: errMsg.errorMessage });
      });
    } else {
      AlertMessage({ type: 'error', msg: err.title || 'An error occured' });
    }
    return false;
  }
};

export const IsUserGroupPresent = async (UserGroupKey: string) => {
  try {
    const res = await axios.put(`${API_URLS.IS_USERGROUP_PRESENT}?UserGroupKey=${UserGroupKey}`);
    if (res.data.message === "User group is present") {
      return true;
    }
    else {
      return false;
    }
  } catch (err) {
    return false;
  }
};

export const GetMobileRoleCodeMaster = async () => {
  try {
    const res = await axios.get<any[]>(API_URLS.GET_MOBILE_ROLE_CODE_MASTER);
    return res.data;
  } catch {
    return [];
  }
};